import { Dialog, Grid, Link, Typography, Stack, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CloseIconButton } from "../Utilities";
import { useMedia } from "../hooks/useMedia";

export default function Copyright({ open, onClose }) {

    const { t } = useTranslation();
    const { links, logos } = useMedia();
    
    return (
        <Dialog
            onClose={onClose}
            open={open}
        >
            <CloseIconButton onClick={onClose} />
            <Grid
                container
                rowSpacing={1}
                direction="column"
                sx={{
                    textAlign: "center",
                    px: "24px",
                    py: "16px",
                    maxWidth: "280px",
                    userSelect: "none",
                    mt: 0
                }}
            >
                <Grid item>
                    <Stack
                        spacing={1}
                        direction="column"
                        sx={{ alignItems: "center" }}
                    >
                        <Link href={links.btv} target='_blank' rel="noopener" onClick={onClose}>
                            <img
                                style={{ width: 200 }}
                                src={logos.btv.dark}
                                alt="BauTV+"
                            />
                        </Link>
                        <Link href={links.netco} target='_blank' rel="noopener" onClick={onClose} sx={{ alignSelf: "flex-end", pb: 0.5 }}>
                            <img
                                style={{ width: 84 }}
                                src={logos.netco}
                                alt="NetCo"
                            />
                        </Link>
                    </Stack>
                </Grid>

                <Grid item sx={{ pb: 1 }}>
                    <Typography sx={{ fontSize: "1rem" }}>
                        {t("copyright.title")}
                    </Typography>
                </Grid>

                <Divider />

                <Grid item sx={{ pb: 1 }}>
                    <Link href={links.privacy} underline="none" target='_blank' rel="noopener" onClick={onClose}>
                        <Typography sx={{ fontSize: "1rem" }}>
                            {t("copyright.privacy")}
                        </Typography>
                    </Link>
                </Grid>

                <Divider />

                <Grid item>
                    <Link href={links.imprint} underline="none" target='_blank' rel="noopener" onClick={onClose}>
                        <Typography sx={{ fontSize: "1rem"}}>
                            {t("copyright.print")}
                        </Typography>
                    </Link>
                </Grid>

            </Grid>
        </Dialog>
    );
}